import React from 'react';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

const ContactPhoneInput = ({
  id = 'contact-phone',
  name = 'phone',
  value,
  onChange,
  placeholder,
  hasError = false,
}) => (
  <div className={`contact-phone-field${hasError ? ' contact-phone-field--error' : ''}`}>
    <PhoneInput
      defaultCountry="cm"
      preferredCountries={['cm', 'fr', 'us', 'gb', 'de', 'be', 'ca']}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="contact-phone-field__control"
      inputClassName="contact-phone-field__input"
      countrySelectorStyleProps={{
        className: 'contact-phone-field__selector',
        buttonClassName: 'contact-phone-field__country-btn',
        buttonContentWrapperClassName: 'contact-phone-field__country-content',
        dropdownArrowClassName: 'contact-phone-field__arrow',
        flagClassName: 'contact-phone-field__flag',
        dropdownStyleProps: {
          className: 'contact-phone-field__dropdown',
          listItemClassName: 'contact-phone-field__dropdown-item',
          listItemDialCodeClassName: 'contact-phone-field__dropdown-dial',
          listItemFlagClassName: 'contact-phone-field__dropdown-flag',
        },
      }}
      inputProps={{
        id,
        name,
        autoComplete: 'tel',
      }}
    />
  </div>
);

export default ContactPhoneInput;
